const qcToolWebUrl = (import.meta.env.VITE_QC_TOOL_WEB_URL ?? '').replace(
  /\/$/,
  '',
);

/** In-app route (or web app URL) a notification opens. */
const LINKS = {
  TASKS_ASSIGNED: '/my-qc-task',
  TASKS_REASSIGNED: '/my-qc-task',
  REVIEWS_ASSIGNED: '/assigned-review-qc-task',
  REVIEW_OUTCOME: '/my-qc-task-reports',
};

/** Types whose page lives in the admin web app (`/projects`). */
const WEB_APP_TYPES = new Set(['BATCH_UPLOADED', 'PROJECT_DEADLINE']);

/**
 * @param {{ type: string }} notification
 * @returns {{ to?: string, href?: string }} `to` for router links, `href` for the web app
 */
export function notificationTarget(notification) {
  const type = notification?.type;
  if (LINKS[type]) return { to: LINKS[type] };
  if (WEB_APP_TYPES.has(type) && qcToolWebUrl) {
    return { href: `${qcToolWebUrl}/projects` };
  }
  return {};
}

/**
 * Short relative time ("just now", "5 min ago", "3 hr ago", "2 days ago"),
 * falling back to a date after a week.
 * @param {string | Date} value
 * @param {number} [now]
 */
export function timeAgo(value, now = Date.now()) {
  const t = new Date(value).getTime();
  if (Number.isNaN(t)) return '';
  const sec = Math.max(0, Math.round((now - t) / 1000));
  if (sec < 60) return 'just now';
  const min = Math.round(sec / 60);
  if (min < 60) return `${min} min ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr} hr ago`;
  const days = Math.round(hr / 24);
  if (days < 7) return `${days} day${days === 1 ? '' : 's'} ago`;
  return new Date(t).toLocaleDateString();
}
